import JsSIP from 'jssip';

class SipVoiceClient extends EventTarget {
  constructor() {
    super();
    this.ua = null;
    this.session = null;
    this.remoteAudio = null;
    this.localAudio = null;
  }

  initialize({ websocketUrl, sipDomain, extension, password }) {
    if (this.ua) {
      this.ua.stop();
    }

    const socket = new JsSIP.WebSocketInterface(websocketUrl);
    const config = {
      sockets: [socket],
      uri: `sip:${extension}@${sipDomain}`,
      password: password,
    };

    this.ua = new JsSIP.UA(config);

    this.ua.on('registered', () => {
      this.dispatchEvent(new CustomEvent('registered'));
    });

    this.ua.on('unregistered', () => {
      this.dispatchEvent(new CustomEvent('unregistered'));
    });

    this.ua.on('registrationFailed', e => {
      this.dispatchEvent(new CustomEvent('registrationFailed', { detail: e }));
    });

    this.ua.on('newRTCSession', data => {
      this.session = data.session;

      if (this.session.direction === 'incoming') {
        this.dispatchEvent(
          new CustomEvent('incomingCall', { detail: this.session })
        );
      }

      this.session.on('peerconnection', () => {
        this.session.connection.addEventListener('track', e => {
          this.remoteAudio = document.createElement('audio');
          this.remoteAudio.srcObject = e.streams[0];
          this.remoteAudio.play();
        });
      });

      this.session.on('ended', () => {
        this.dispatchEvent(new CustomEvent('call:disconnected'));
        this.session = null;
      });

      this.session.on('failed', () => {
        this.dispatchEvent(new CustomEvent('call:disconnected'));
        this.session = null;
      });
    });

    this.ua.start();
  }

  makeCall(targetUri) {
    if (!this.ua) return;
    const options = {
      mediaConstraints: { audio: true, video: false },
    };
    this.session = this.ua.call(targetUri, options);
  }

  answerCall() {
    if (!this.session) return;
    const options = {
      mediaConstraints: { audio: true, video: false },
    };
    this.session.answer(options);
  }

  endCall() {
    if (!this.session) return;
    this.session.terminate();
  }
}

export default new SipVoiceClient();
